import React from 'react';
import { getFirstParagraph, getPublicVideoUrl, isVideoUrl } from '../util/util';
import { Server } from 'src/server/server';
import './Modal.css'

interface AddEmbedModalProps {
  open: boolean;
  onEmbed: Function;
  onClose: Function;
  quillRef: any;
  quillPosition: number;
}

interface AddEmbedModalState {
  url: string;
  unfurl: any;
  loading: boolean;
}

class AddEmbedModal extends React.Component<AddEmbedModalProps, AddEmbedModalState> {
  constructor(props: AddEmbedModalProps) {
    super(props);
    this.state = {
      url: '',
      unfurl: null,
      loading: false
    }
  }

  componentDidUpdate(prevProps: Readonly<AddEmbedModalProps>) {
    if(!prevProps.open && this.props.open) {
      this.setState({url: '', unfurl: null});
    } 
  }

  async onInsert() {
    this.props.onEmbed(this.state.url);
  }

  render() {
    if(!this.props.open)
      return null;

    return (
      <div className="modal open">
        <div className="modal-content">
          <div className="site-page-column">
            <div style={{textAlign: 'center'}}>Embed Content</div>
            <input 
              autoFocus={true}
              placeholder="Enter the URL"
              value={this.state.url}
              onChange={(e:any)=>this.setState({url: e.currentTarget.value})}
            />
            <div className="site-page-row" style={{justifyContent: 'space-between'}}>
              <button disabled={this.state.loading} onClick={()=>this.props.onClose()}>Cancel</button>
              <button disabled={this.state.loading} onClick={()=>this.onInsert()}>Insert</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddEmbedModal;